<template>
  <div class="info">
    <h1 class="desktop">Bolt<br>The Drone Dog</h1>
    <h1 class="phone">Bolt The Drone Dog</h1>

    <div class="icon-wrapper">
      <a href="https://www.recon.com/boltbdsm" target="_blank">
        <img src="../assets/recon.png" alt="recon" />
      </a>
      <a href="http://www.twitter.com/BoltBDSM" target="_blank">
        <img src="../assets/twitter.png" alt="twitter" />
      </a>
      <a href="https://www.instagram.com/boltthedronedog/" target="_blank">
        <img src="../assets/instagram.png" alt="instagram" />
      </a>
      <a href="mailto:kinkyalexc@yahoo.com" target="_blank">
        <img src="../assets/email.png" alt="email" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Info'
}
</script>

<style lang="scss">
.info {
  position: fixed;
  box-sizing: border-box;
  z-index: 1000;
  top: 0;
  left: 0;
  //transform: translateY(-50%);
  //right: 20px;
  width: 100%;
  height: auto;
  background: rgba(white, 0.7);
  padding: 10px 15px;
  border-radius: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;

  @media (min-width: 767px) {
    font-size: 36px;
    top: 50%;
    left: unset;
    transform: translateY(-50%);
    right: 20px;
    flex-direction: column;
    width: 300px;
    align-items: flex-end;
  }

  h1 {
    margin-top: 0;
    margin-bottom: 0;
    font-size: 20px;
    text-align: left;
    text-transform: uppercase;

    @media (min-width: 767px) {
      font-size: 36px;
      text-align: right;
    }
  }

  .desktop {
    display: none;
    margin-bottom: 20px;

    @media (min-width: 767px) {
      display: block;
    }
  }

  .phone {
    display: block;

    @media (min-width: 767px) {
      display: none;
    }
  }

  .icon-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: flex-end;

    a {
      margin-left: 10px;
    }

    @media (min-width: 767px) {
      flex-direction: column;
    }
  }
}
</style>
